<!-- 阻焊颜色 -->
<template>
  <BaseFormItem2
    class="color"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
        :style="colors[item.value]"
        :class="`color__icons__${colors[item.value]['--checked-icon'] || 'icon_radio2'}`"
      >
        <ColorBlock :color="item.value" />
        {{ item.label }}
      </el-radio-button>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import ColorBlock from '@@/components/colorBlock/index'

import { COLORS } from '@@/utils/constant'
import { getROGERSFields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: '绿色'
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ColorBlock
  },
  data() {
    return {
      val: this.value,
      colors: COLORS
    }
  },
  computed: {
    fields() {
      return getROGERSFields('color')
    },
    options() {
      const { val, fields } = this
      const otherOptions = ['哑光绿油', '哑光蓝油']
      let options = fields.options.filter(item => !otherOptions.includes(item.value))
      // 当值为 哑光绿油 || '哑光蓝油' 时 才显示对应的选项
      if (otherOptions.includes(val)) {
        options.push(...fields.options.filter(item => item.value === val))
      }
      
      return options
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      const { val, value } = this
      this.$emit('input', val)
      if (val != value) {
        this.$emit('change', val)
      }
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.color {
  .base-radio-group ::v-deep .el-radio-button {
    // 选中状态
    $--radio-checked-font-color: var(--color);
    $--radio-checked-border-color: var(--border-color);
    $--radio-checked-background-color: var(--background);
    // hover状态
    $--radio-hover-font-color: var(--color);
    $--radio-hover-border-color: var(--border-color);
    .el-radio-button__inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    // 选中
    &.is-active {
      .el-radio-button__inner {
        color: $--radio-checked-font-color;
        border-color: $--radio-checked-border-color;
        background: $--radio-checked-background-color;
        box-shadow: none;
        // box-shadow: 0 0 3px $--radio-border-color;
      }
      // 右下角选中icon
      @for $i from 1 through 5 {
        &.color__icons__icon_radio_#{$i} {
          .el-radio-button__inner::after {
            background: url("~@@/assets/img/icons/icon_radio_#{$i}.png");
          }
        }
      }
    }
    // hover
    &:not(.is-disabled):not(.is-active):hover {
      .el-radio-button__inner {
        color: $--radio-hover-font-color;
        border-color: $--radio-hover-border-color;
        background: $--radio-hover-background-color;
      }
    }
    // 左边框
    &:not(:first-child) {
      border-left: 1px solid transparent;
      margin-left: -1px;
      // transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transition: none;
      &.is-active:not(.is-disabled),
      &:not(.is-disabled):hover {
        border-left-color: $--radio-checked-border-color;
      }
    }
  }
}
</style>